import { SET_CAT_ID, BEFORE_MODAL_MENU } from '../../redux/types';

export const beforeModalMenu = () => {
    return {
        type: BEFORE_MODAL_MENU
    }
}

export const setCat = (id = null) => dispatch => {
    if (id) {
        dispatch({
            type: SET_CAT_ID,
            payload: id
        })
    }
}



